import PageDescription from "../DataAnalyst/sections/PageDescription";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import AppTour from "../../../components/AppTour/AppTour";
import StudioGoals from "./StudioGoals";
import MastersLibrary from "./components/MastersLibrary";
import MixesLibrary from "./components/MixesLibrary/MixesLibrary";
import { studioGoalsTourSteps } from "../../../components/AppTour/ModuleTourSteps";

export default function UrStudio() {
  const navigate = useNavigate();
  const { hash } = useLocation();
  const [runTour, setRunTour] = useState(false);
  const [tourSteps, setTourSteps] = useState(studioGoalsTourSteps);

  // Handle hash-based tour triggering
  useEffect(() => {
    if (hash === "#start-tour") {
      setTourSteps(studioGoalsTourSteps);
      setRunTour(true);
    }
  }, [hash]);

  const handleNew = () => {
    navigate('/admin/urstudio/audio-engineer');

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleUploadNew = () => {
    navigate('/admin/urstudio/mixing-engineer');

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getSettings = (e) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="DataAnalyst-page py-5">
      <div className="container max-w-full">
        <AppTour
          tourSteps={tourSteps}
          runTour={runTour}
          setRunTour={setRunTour}
        />
        <PageDescription
          title="UrStudio"
          description="Your all-in-one suite for mixing, mastering, and more — built with smart, genre-aware AI."
        />
        <div className="mt-4 p-4 md:p-8 bg-theme_clr1 font-jakarta rounded-2xl">
          <StudioGoals />
        </div>

        <div className="bg-theme_clr1 text-white rounded-xl p-4 mt-4" data-tour="mixes-library">
          <MixesLibrary addNew={handleUploadNew} handleSettings={getSettings} />
        </div>

        <div className="mt-4" data-tour="masters-library">
          <MastersLibrary addNew={handleNew} handleSettings={getSettings} />
        </div>
      </div>
    </div>
  );
}
